"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyHeightMapToPlaneGeometry = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
var realms_utils_1 = require("realms-utils");
/**
 * Updates the current plane geometry with the height map applied
 */
function applyHeightMapToPlaneGeometry(planeGeometry, heightMap) {
    var _a = planeGeometry.parameters, width = _a.width, height = _a.height, widthSegments = _a.widthSegments, heightSegments = _a.heightSegments;
    // Unit length
    var widthUnit = width / widthSegments;
    var heightUnit = height / heightSegments;
    /**
     * Gets the height at a specific index. If it is out of bounds return 0
     */
    var getCellValue = function (x, y) {
        var _a;
        if (x < 0 || x >= heightMap.width || y < 0 || y >= heightMap.height) {
            return 0;
        }
        return (_a = heightMap.data[y * heightMap.width + x]) !== null && _a !== void 0 ? _a : 0;
    };
    var vertices = [];
    var normals = [];
    var uvs = [];
    for (var y = 0; y < heightMap.height; y += 1) {
        for (var x = 0; x < heightMap.width; x += 1) {
            // Add vertices to make a square. (Square is made up of two triangles)
            // For more context see:
            // https://threejs.org/docs/#api/en/core/BufferGeometry
            //
            // The value of each vertice is the average value of the surrounding squares
            var topLeftValue = (0, realms_utils_1.avg)(getCellValue(x - 1, y - 1), // Top Left of vertex
            getCellValue(x, y - 1), // Top Right of vertex
            getCellValue(x, y), // Bottom Right of vertex
            getCellValue(x - 1, y) // Bottom Left of vertex
            );
            var topRightValue = (0, realms_utils_1.avg)(getCellValue(x, y - 1), // Top Left of vertex
            getCellValue(x + 1, y - 1), // Top Right of vertex
            getCellValue(x + 1, y), // Bottom Right of vertex
            getCellValue(x, y) // Bottom Left of vertex
            );
            var bottomLeftValue = (0, realms_utils_1.avg)(getCellValue(x - 1, y), // Top Left of vertex
            getCellValue(x, y), // Top Right of vertex
            getCellValue(x - 1, y + 1), // Bottom Right of vertex
            getCellValue(x, y + 1) // Bottom Left of vertex
            );
            var bottomRightValue = (0, realms_utils_1.avg)(getCellValue(x, y), // Top Left of vertex
            getCellValue(x + 1, y), // Top Right of vertex
            getCellValue(x + 1, y + 1), // Bottom Right of vertex
            getCellValue(x, y + 1) // Bottom Left of vertex
            );
            var halfWidth = width / 2;
            var halfHeight = height / 2;
            // Calculate proper UV coordinates that match standard Three.js orientation
            // The UV Code is generated by Claude - it works - but no idea how
            var uBottom = x / widthSegments;
            var uTop = (x + 1) / widthSegments;
            var vBottom = y / heightSegments;
            var vTop = (y + 1) / heightSegments;
            // Triangle 1 (Bottom Right)
            vertices.push((x + 1) * widthUnit - halfWidth, (y + 1) * heightUnit - halfHeight, bottomRightValue);
            normals.push(0, 0, 1);
            uvs.push(uTop, vTop);
            // Triangle 1 (Bottom Left)
            vertices.push(x * widthUnit - halfWidth, (y + 1) * heightUnit - halfHeight, bottomLeftValue);
            normals.push(0, 0, 1);
            uvs.push(uBottom, vTop);
            // Triangle 1 (Top Left)
            vertices.push(x * widthUnit - halfWidth, y * heightUnit - halfHeight, topLeftValue);
            normals.push(0, 0, 1);
            uvs.push(uBottom, vBottom);
            // Triangle 2 (Top Right)
            vertices.push((x + 1) * widthUnit - halfWidth, y * heightUnit - halfHeight, topRightValue);
            normals.push(0, 0, 1);
            uvs.push(uTop, vBottom);
            // Triangle 2 (Bottom Right)
            vertices.push((x + 1) * widthUnit - halfWidth, (y + 1) * heightUnit - halfHeight, bottomRightValue);
            normals.push(0, 0, 1);
            uvs.push(uTop, vTop);
            // Triangle 2 (Top Left)
            vertices.push(x * widthUnit - halfWidth, y * heightUnit - halfHeight, topLeftValue);
            normals.push(0, 0, 1);
            uvs.push(uBottom, vBottom);
        }
    }
    var positionAttribute = new realms_three_1.default.BufferAttribute(new Float32Array(vertices), 3);
    planeGeometry.setAttribute("position", positionAttribute);
    positionAttribute.needsUpdate = true;
    var normalAttribute = new realms_three_1.default.BufferAttribute(new Float32Array(normals), 3);
    planeGeometry.setAttribute("normal", normalAttribute);
    normalAttribute.needsUpdate = true;
    var uvAttribute = new realms_three_1.default.BufferAttribute(new Float32Array(uvs), 2);
    planeGeometry.setAttribute("uv", uvAttribute);
    uvAttribute.needsUpdate = true;
    planeGeometry.setIndex(null);
    return planeGeometry;
}
exports.applyHeightMapToPlaneGeometry = applyHeightMapToPlaneGeometry;
